// @ts-nocheck

import { Buffer } from 'buffer';
import gc from './gost';

const alg = { name: 'GOST R 34.12', version: 2015, length: 128, padding: 'PKCS5P' };

function arrayBufferToBufferCycle(ab: ArrayBuffer): ArrayBuffer {
    const buffer = new Buffer(ab.byteLength);
    const view = new Uint8Array(ab);
    for (let i = 0; i < buffer.length; ++i) {
        buffer[i] = view[i];
    }
    return buffer;
}

// eslint-disable-next-line
export const encrypt = (key: string, data: any): Promise<ArrayBuffer> => {
    const gostCrypto = gc;

    return gostCrypto.subtle
        .importKey('raw', gc.coding.Hex.decode(key), { name: 'GOSTR3412' }, true, ['deriveKey', 'sign', 'encrypt'])
        .then((baseKey: CryptoKey) => {
            return gostCrypto.subtle.encrypt(alg, baseKey, data);
        });
};

export const encryptJson = (key: string, json: string): Promise<ArrayBuffer> => {
    const gostCrypto = gc;

    return gostCrypto.subtle
        .importKey('raw', gc.coding.Base64.decode(key), { name: 'GOSTR3412' }, true, ['deriveKey', 'sign', 'encrypt'])
        .then((baseKey: CryptoKey) => {
            return gostCrypto.subtle
                .encrypt(
                    alg,
                    baseKey,
                    gostCrypto.coding.Base64.decode(btoa(unescape(encodeURIComponent(json))), 'utf8'),
                )
                .then((data: never) => gostCrypto.coding.Base64.encode(data));
        });
};

// eslint-disable-next-line
export const decryptJson = (key: string, data: any): Promise<ArrayBuffer> => {
    const gostCrypto = gc;
    return gostCrypto.subtle
        .importKey('raw', gc.coding.Base64.decode(key), { name: 'GOSTR3412' }, true, [
            'deriveKey',
            'sign',
            'encrypt',
            'decrypt',
        ])
        .then((baseKey: never) => {
            return gostCrypto.subtle.decrypt(alg, baseKey, gostCrypto.coding.Base64.decode(data));
        })
        .then((d: never) => {
            return gostCrypto.coding.Chars.encode(d, 'utf8');
        });
};

// eslint-disable-next-line
export const decryptJsonSSE = (key: string, data: any): Promise<ArrayBuffer> => {
    const gostCrypto = gc;
    return gostCrypto.subtle
        .importKey('raw', gc.coding.Base64.decode(key), { name: 'GOSTR3412' }, true, [
            'deriveKey',
            'sign',
            'encrypt',
            'decrypt',
        ])
        .then((baseKey: Uint8Array) => {
            return gostCrypto.subtle.decrypt(alg, baseKey, gostCrypto.coding.Base64.decode(data));
        })
        .then((data: Uint8Array) => {
            return new TextDecoder('utf8').decode(data);
        });
};

// eslint-disable-next-line
export const decrypt = (key: string, data: any): Promise<ArrayBuffer> => {
    const gostCrypto = gc;
    return gostCrypto.subtle
        .importKey('raw', gc.coding.Hex.decode(key), { name: 'GOSTR3412' }, true, [
            'deriveKey',
            'sign',
            'encrypt',
            'decrypt',
        ])
        .then((baseKey: never) => {
            return gostCrypto.subtle.decrypt(alg, baseKey, arrayBufferToBufferCycle(data));
        });
};

// eslint-disable-next-line
export const decryptFile = (key: string, data: any): Promise<ArrayBuffer> => {
    const gostCrypto = gc;
    return gostCrypto.subtle
        .importKey('raw', gc.coding.Base64.decode(key), { name: 'GOSTR3412' }, true, [
            'deriveKey',
            'sign',
            'encrypt',
            'decrypt',
        ])
        .then((baseKey: never) => {
            return gostCrypto.subtle.decrypt(alg, baseKey, arrayBufferToBufferCycle(data));
        });
};

// eslint-disable-next-line
export const encryptFile = (key: string, data: any): Promise<ArrayBuffer> => {
    const gostCrypto = gc;

    return gostCrypto.subtle
        .importKey('raw', gc.coding.Base64.decode(key), { name: 'GOSTR3412' }, true, ['deriveKey', 'sign', 'encrypt'])
        .then((baseKey: never) => {
            return gostCrypto.subtle.encrypt(alg, baseKey, data);
        });
};

export const generateKey = (): string => {
    const gostCrypto = gc;

    return gostCrypto.subtle
        .generateKey('GOSTR3412', true, ['deriveKey', 'sign', 'encrypt', 'decrypt'])
        .then((keyPair: never) => {
            // Store key in secluded place
            return gostCrypto.subtle.exportKey('raw', keyPair).then((result: never) => {
                return gostCrypto.coding.Base64.encode(result);
                //return '7Dng+cBXrXiFDzbptVZnKLO9A2qwqavPUnauyvTv70c=';
            });
        });
};
